import React from "react";
import "./accessories.style.sass";
import { Alert, Button } from "rsuite";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectAccessory } from "../../redux/users/users.selector";
import { SetProduct, SetAccessories } from "../../redux/site/site.actions";
import { SetBuyCart } from "../../redux/cart/cart.actions";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import { selectAccessories } from "../../redux/site/site.selector";
import { css } from "@emotion/react";
import GridLoader from "react-spinners/GridLoader";
import { HandleErorr, Setting } from "../../setting";

class Accessories extends React.Component {
	componentDidMount() {
		const { SetAccessories } = this.props;
		Axios.get(`${Setting.apiUrl}api/product/list?type=accessory`)
			.then((res) => {
				SetAccessories(res.data.data);
			})
			.catch((res) => HandleErorr(res));
	}
	render() {
		const { SetProduct, sub, getAccessories } = this.props;

		// getProducts?.map(({ link }) => console.log(link));

		const HandleClick = (item) => {
			SetProduct(item);
		};
		const override = css`
			display: block;
			margin: 40px auto;
			border-color: red;
		`;
		return (
			<div
				className="products"
				style={sub ? { backgroundColor: "transparent" } : null}
			>
				<div className="product-container">
					<h3>
						لوازم جانبی <span>زیتونیکس</span>
					</h3>
					{getAccessories ? (
						<div className="product-area">
							{getAccessories.map((item) => (
								<div
									key={item.id}
									className="product"
								>
									<img
										src={`${Setting.apiUrl}${item.image}`}
										alt="xitonix accessories"
									/>
									<h6>{item.name}</h6>
									<div className="btn-add-area">
										<Link to="product/singleProduct">
											<Button onClick={() => HandleClick(item)}>مشاهده</Button>
										</Link>
									</div>
								</div>
							))}
						</div>
					) : (
						<GridLoader
							color="#FF8F3C"
							loading={true}
							css={override}
							size={20}
							margin={7}
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	SetProduct: (Accessory) => dispatch(SetProduct(Accessory)),
	SetAccessories: (accessories) => dispatch(SetAccessories(accessories)),
});
const mapStateToProps = createStructuredSelector({
	productItem: selectAccessory,
	getAccessories: selectAccessories,
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Accessories)
);
